module.exports = global["InfoBox"] = require("-!/var/www/ridewithgps.com/releases/20261103180724/node_modules/exports-loader/index.js?InfoBox!./infobox.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?InfoBox!./~/exports-loader?InfoBox!./public/javascripts/js_maps/infobox.js-exposed
// module id = 24
// module chunks = 1